import gql from 'graphql-tag';

const getCompanyUsersQuery = gql`
query getCompanyUsers($_id: String!){
   company(_id: $_id){
                users{
                  firstName
                  lastName
                  _id
                  email
                  verified
                  phone
                  idNumber
                  coins
                  steps
                  roles
                  company {
                    _id
                    name
                  }
                }
              }
  
}

`;

export default getCompanyUsersQuery;
